import React from "react";
import PropTypes from "prop-types";

const Tabs = ({ tabs, activeIndex, onChange }) => {
  return (
    <div className="w-full">
      <div className="flex gap-1 overflow-x-auto   ">
        {tabs.map((tab, index) => {
          const isActive = index === activeIndex;

          return (
            <button
              key={tab.key ?? index}
              type="button"
              onClick={() => onChange(index)}
              className={`h-10 px-4 rounded-t-lg border-t border-r border-l  shadow-sm transition whitespace-nowrap ${
                isActive
                  ? "bg-ananas border-ananas text-primary -mb-[1px] opacity-80"
                  : "bg-ananas/30 border-ananas/20 text-gray-600 hover:bg-white hover:border-gray-200"
              }`}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeIndex: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Tabs;
